import React from 'react';
import './index.scss';

interface iProps {
    isSecondary?: boolean;
    title: string | undefined;
    banner: string | undefined;
}

export const Coleccion = function (props: iProps){
    return (
        <div className="c_coleccion__container" style={{backgroundImage: `url("/tematicos/${props.banner}")`}}>
            <div className={`c_coleccion__layer ${props.isSecondary ? 'secondary' : ''}`}>
                <p className={`c_coleccion__title ${props.isSecondary ? 'secondary' : ''} e-h5 e-h6:md`}>{props.title}</p>
            </div>
        </div>
    )
}